import { JsonDataService } from 'services/json-data.service';
import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { RemoteService } from 'app/services/remote.service';
import { LocalStorageService } from 'ngx-store';
import { MatDialog } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DeleteConfirmationModalComponent, ConfirmDialogModel } from './../delete-confirmation-modal/delete-confirmation-modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  defaultData: any;

  constructor(private jsonDataService: JsonDataService,
    public router: Router,
    private remoteService: RemoteService,
    public ls: LocalStorageService,
    public dialog: MatDialog,
    private notifierService: NotifierService) {
  }

  ngOnInit() {
    this.jsonDataService.getJSON('defaults', 'default.json')
      .subscribe(res => this.defaultData = res);
  }

  logoutUser() {
    const tokenData = this.ls.get('tokenDetails');
    const payload = {
      access_token: tokenData.access_token,
      refresh_token: tokenData.refresh_token,
      before_policy: tokenData.before_policy,
      expires_in: tokenData.expires_in,
      refresh_expires_in: tokenData.refresh_expires_in,
      scope: tokenData.scope,
      session_state: tokenData.session_state,
      token_type: tokenData.token_type,
      user_name: this.ls.get('userName')
    }
    this.remoteService.logout(payload).subscribe(res => {
      this.ls.clear();
      this.router.navigate(['/login']);
    }, (error) => {
      this.ls.clear();
      this.router.navigate(['/login']);
    });
  }

  navigatingToHomePage() {
    if (this.router.url == '/login' || this.router.url == '/signup' || this.router.url == '/forgot-password' || this.router.url.split('?')[0] == '/change-password' || this.router.url == '/pricing' || this.router.url == '/about' || this.router.url == '/my-portfolio-pro' || this.router.url == '/complete-signup' || this.router.url.startsWith('/help')) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/user/my-dashboard']);
    }
  }

  isJsonError(err) {
    try {
      JSON.parse(err);
    } catch (e) {
      return false;
    }
    return true;
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContent, {
      width: "450px"
    });
    dialogRef.afterClosed().subscribe(result => {
      this.ls.clear();
      this.router.navigate(['/login']);
    });
  }

  confirmDialog(): void {
    const message = `Are you sure you want to close your account?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message);
    const dialogRef = this.dialog.open(DeleteConfirmationModalComponent, {
      width: "350px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      //@ts-ignore
      var $body = $(document.body);
      //@ts-ignore
      $body.css("overflow", "auto");
      //@ts-ignore
      $body.width("auto");
      if (dialogResult.reason) {
        const payload = {
          email: this.ls.get('investorDetails').userId.email,
          reasonForDelete: dialogResult.reason
        }
        this.remoteService.deleteUser(payload).subscribe(res => {
          this.openDialog();
        }, error => {
          this.notifierService.notify('error', error);
        })
      }
    });
  }

  cashRequestDialog(value): void {
    const dialogRef = this.dialog.open(CashRequestDialog, {
      width: "350px",
      data: { name: value }
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      //@ts-ignore
      var $body = $(document.body);
      //@ts-ignore
      $body.css("overflow", "auto");
      //@ts-ignore
      $body.width("auto");
    });
  }
}

@Component({
  selector: 'dialog-content',
  templateUrl: 'dialog-content.html',
})
export class DialogContent {
  constructor(public dialogRef: MatDialogRef<DialogContent>, ) {
  }
  onConfirm(): void {
    this.dialogRef.close(true);
  }
}

@Component({
  selector: 'cash-request-dialog',
  templateUrl: 'cash-request-dialog.html',
})
export class CashRequestDialog {
  requestCash: FormGroup;
  formSumitAttempt: boolean;
  moneyData: any;
  displayObject = {
    title: 'Deposit Details',
    lable: 'Deposit Money',
    buttonName: 'Deposit'
  };
  portfolio = [];
  selectedPortfolio: any;
  constructor(public dialogRef: MatDialogRef<DialogContent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmUserDialogModel,
    private fb: FormBuilder,
    private notifierService: NotifierService,
    public ls: LocalStorageService,
    private remoteService: RemoteService,
    private datePipe: DatePipe) {
    this.getPortfolioStockDetails(this.ls.get('investorDetails').id);
    this.moneyData = data
  }

  ngOnInit() {
    try {
      //@ts-ignore
      $('.datepicker').datepicker({ maxDate: new Date() });
    } catch (e) { }
    this.requestCash = this.fb.group({
      requestMoney: ['', Validators.required],
      transferDate: ['', Validators.required],
      comments: [''],
      portfolioList: ['', Validators.required]
    })
    if (this.moneyData.name === 'deposit') {
      this.displayObject = {
        title: 'Cash Transfer Details',
        lable: 'Transfer Money',
        buttonName: 'Transfer'
      }
    } else {
      this.displayObject = {
        title: 'Withdraw Details',
        lable: 'Withdraw Money',
        buttonName: 'Withdraw'
      }
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.requestCash.get(field).valid && this.requestCash.get(field).touched) ||
      (this.requestCash.get(field).untouched && this.formSumitAttempt)
    );
  }

  onConfirm(): void {
    if (this.requestCash.valid) {
      if (this.ls.get('investorDetails').availableCash < this.requestCash.value.requestMoney) {
        return this.notifierService.notify('error', 'The amount is not sufficient to transfer.');
      }
      const payload = {
        "amount": this.requestCash.value.requestMoney,
        portfolioId: this.selectedPortfolio.portfolioId,
        transactionDate: this.datePipe.transform(this.requestCash.value.transferDate, 'yyyy-MM-dd')
      }
      this.remoteService.transferMoneyToPortfolio(payload).subscribe(res => {
        this.ls.set('portfolioRemainingCash', this.ls.get('portfolioRemainingCash') + this.requestCash.value.requestMoney);
        this.dialogRef.close(true);
        this.notifierService.notify('success', 'Cash transferred successfully.');
        this.investorDetailsgetByUsingEmailId();
      }, error => {
        this.remoteService.errorFunction(error);
      })
    } else {
      this.formSumitAttempt = true;
      this.notifierService.notify('error', 'Invalid Inputs');
    }
  }

  investorDetailsgetByUsingEmailId() {
    this.remoteService.getInvestorDetailsByUsingEmail(this.ls.get('userName'), (res) => {
      this.ls.set('investorDetails', JSON.parse(res));
    }, (error) => {
      this.remoteService.errorFunction(error);
    });
  }

  getPortfolioStockDetails(id) {
    this.remoteService.getAllPortfolioByInvestorId(id, (res) => {
      this.portfolio = JSON.parse(res);
    }, (error) => {
      this.remoteService.errorFunction(error);
    });
  }

  selectPortfolio(data) {
    this.selectedPortfolio = data;
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  selectedtransferDate(date) {
    this.requestCash.patchValue({ transferDate: this.datePipe.transform(date, 'mediumDate') });
  }
}

export class ConfirmUserDialogModel {
  constructor(public dialogData: object) { }
}